type GlobirdHeaderType = (string | JSX.Element | undefined | null)[];
type GlobirdRowType = (string | JSX.Element | undefined | null)[][];

class GlobirdTableContainer {
    headerList: GlobirdHeaderType = [];
    rowList: GlobirdRowType = [];

    constructor(
        headerList?: GlobirdHeaderType,
        rowList?: GlobirdRowType) {

        headerList && (this.headerList = headerList);
        rowList && (this.rowList = rowList);
    }
}

export type { GlobirdRowType }
export { GlobirdTableContainer }